import React, { Component } from 'react';
import '../css/Login.css';
import Notifications, { notify } from 'react-notify-toast';
import AuthService from './AuthService';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Fade from '@material-ui/core/Fade';
import LinearProgress from '@material-ui/core/LinearProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import EmailOutlined from '@material-ui/icons/EmailOutlined';
import LockOutlined from '@material-ui/icons/LockOutlined';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const styles = theme => ({
    fieldRoot: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            backgroundColor: '#f8fafc',
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2962ff',
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2962ff',
            borderWidth: 1.5,
        },
        '& .MuiOutlinedInput-input': {
            fontSize: 15,
            padding: '14px 14px',
        },
        '& .MuiInputLabel-root': {
            fontSize: 14,
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#2962ff',
        },
    },
    submitBtn: {
        background: 'linear-gradient(135deg, #2962ff 0%, #5d8bff 100%)',
        color: '#ffffff',
        textTransform: 'none',
        fontSize: 15,
        fontWeight: 600,
        height: 46,
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(41, 98, 255, 0.3)',
        '&:hover': {
            background: 'linear-gradient(135deg, #1e4fd6 0%, #4a76e6 100%)',
            boxShadow: '0 6px 16px rgba(41, 98, 255, 0.4)',
        },
        '&:disabled': {
            background: '#cfd8e8',
            color: '#ffffff',
        },
    },
});

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            isLoading: false,
            showPassword: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.Auth = new AuthService();
    }
    componentWillMount() {
        if (this.Auth.loggedIn())
            this.props.history.replace('/');
    }
    onSubmit(e) {
        e.preventDefault();
        this.setState({
            isLoading: true
        })
        this.Auth.login(this.state.username, this.state.password)
            .then(res => {
                this.setState({
                    username: "",
                    password: "",
                    isLoading: false
                });

                window.location.reload()
            })
            .catch(err => {
                notify.show('Wrong Username or password', "error", 3000);
                this.setState({
                    isLoading: false
                })
            });
    }
    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    toggleShowPassword = () => {
        this.setState((s) => ({ showPassword: !s.showPassword }));
    };

    render() {
        const { classes } = this.props;
        return (
            <section className="login-shell">
                <Notifications />

                <Fade in={true} timeout={{ enter: 800 }}>
                    <div className="login-grid">
                        {/* LEFT — BRAND PANEL */}
                        <aside className="login-brand-panel">
                            <div className="login-brand-overlay" />
                            <div className="login-brand-content">
                                <div className="login-brand-mark">IAC</div>
                                <h1 className="login-brand-title">
                                    Internship &amp; Apprenticeship Cell
                                </h1>
                                <div className="login-brand-college">
                                    Dispur College, Guwahati
                                </div>
                                <div className="login-brand-divider" />
                                <p className="login-brand-tagline">
                                    Bridging academia with industry — managing internships,
                                    apprenticeships, and student opportunities from a single
                                    place.
                                </p>

                                <ul className="login-brand-features">
                                    <li>Manage internship &amp; apprenticeship divisions</li>
                                    <li>Publish notices, reports &amp; documents</li>
                                    <li>Coordinate with students and industry partners</li>
                                </ul>
                            </div>
                            <div className="login-brand-footer">
                                &copy; {new Date().getFullYear()} Dispur College. All rights reserved.
                            </div>
                        </aside>

                        {/* RIGHT — FORM PANEL */}
                        <main className="login-form-panel">
                            <div className="login-form-card">
                                {this.state.isLoading && (
                                    <LinearProgress className="login-progress" />
                                )}

                                <div className="login-form-header">
                                    <span className="login-eyebrow">Admin Console</span>
                                    <h2 className="login-form-title">Welcome back</h2>
                                    <p className="login-form-subtitle">
                                        Sign in to continue to the dashboard
                                    </p>
                                </div>

                                <form onSubmit={this.onSubmit} className="login-form">
                                    <TextField
                                        required
                                        fullWidth
                                        autoFocus
                                        variant="outlined"
                                        label="Email address"
                                        placeholder="you@dispurcollege.ac.in"
                                        name="username"
                                        type="email"
                                        value={this.state.username}
                                        onChange={this.handleChange}
                                        className={classes.fieldRoot}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <EmailOutlined style={{ color: '#5a6374', fontSize: 20 }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />

                                    <TextField
                                        required
                                        fullWidth
                                        variant="outlined"
                                        label="Password"
                                        placeholder="Enter your password"
                                        name="password"
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        value={this.state.password}
                                        onChange={this.handleChange}
                                        className={classes.fieldRoot}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <LockOutlined style={{ color: '#5a6374', fontSize: 20 }} />
                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        size="small"
                                                        onClick={this.toggleShowPassword}
                                                        tabIndex={-1}
                                                    >
                                                        {this.state.showPassword
                                                            ? <VisibilityOff style={{ fontSize: 20, color: '#5a6374' }} />
                                                            : <Visibility style={{ fontSize: 20, color: '#5a6374' }} />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />

                                    <div className="login-form-row">
                                        <Link to="/forgotpassword" className="login-forgot-link">
                                            Forgot password?
                                        </Link>
                                    </div>

                                    <Button
                                        type="submit"
                                        fullWidth
                                        disabled={this.state.isLoading}
                                        className={classes.submitBtn}
                                    >
                                        {this.state.isLoading ? 'Signing in…' : 'Sign in'}
                                    </Button>
                                </form>

                                <div className="login-form-footnote">
                                    Restricted access. Authorised personnel only.
                                </div>
                            </div>
                        </main>
                    </div>
                </Fade>
            </section>
        );
    }
}

export default withStyles(styles)(Login);